import { createContext, useContext } from 'react';
import type { IntlShape } from 'react-intl';

import type { Messages } from '@/lib/i18nOverrides/mergeOverrides';

export interface TextOverridesContextValue {
  /** Intl with the org overrides but never markers — the editor's own UI renders with it. */
  readonly plainIntl: IntlShape;
  /** Static catalog of the locale: the "original" texts. */
  readonly baseMessages: Messages;
  /** The org's overrides for the locale, as the service sent them (before the guard). */
  readonly overrides: Messages;
  /** Catalog ⊕ guarded overrides: the texts on screen. */
  readonly messages: Messages;
  readonly orgId: string | null;
  readonly locale: string;
}

export const TextOverridesContext = createContext<TextOverridesContextValue | null>(null);

export const useTextOverridesContext = (): TextOverridesContextValue => {
  const value = useContext(TextOverridesContext);
  if (value === null) throw new Error('useTextOverridesContext: render inside <OrgIntlProvider>');
  return value;
};
